import React from 'react'
import { graphql } from 'gatsby'
import { Helmet } from "react-helmet"

import Layout from '../components/Layout'
import JumboTron from '../components/JumboTron'
import Blocks from '../lib/blocks';
import MetaTags from '../components/MetaTags';

export default function Page({ data, location })  {
    const page = data.datoCmsPage

    let blocks = [];

    if (page.blocks.length) {
        blocks = Blocks(page.blocks, "mt-20");
    }

    const metaTags = MetaTags(page.seoMetaTags);

    return (
        <Layout>
            <Helmet title={page.pageTitle}>
               {metaTags}
            </Helmet>
            {page.headerImage && (
                <JumboTron
                    alignment={page.headerTextAlignment}
                    text={page.headerText}
                    image={{
                        url: `${
                            page.headerImage.url
                        }?fit=crop&h=640&w=1600&crop=faces`,
                    }}
                />
            )}

            {blocks && blocks.map(el => el)}

        </Layout>
    )
}

export const query = graphql`
    query($slug: String!) {
            datoCmsPage(slug: {eq: $slug}) {
                title
                pageTitle
                headerImage {
                    url
                }
                seoMetaTags {
                    tags
                }
                headerText
                headerTextAlignment
                blocks {
                    ... on DatoCmsImageAndText {
                        model { apiKey }
                        title
                        text
                        flipTextAndImage
                        hideImageOnMobile
                        image {
                            url
                            alt
                            title
                        }
                        video {
                            thumbnailUrl
                            url
                            providerUid
                        }
                    }

                    ... on DatoCmsImageWithInformation {
                        model { apiKey }
                        title
                        text
                        flipTitleAndBlock
                        titleAlignment
                        smallText
                        image {
                            url
                            alt
                            title
                        }
                    }

                    ... on DatoCmsText {
                        model { apiKey }
                        leftColumn
                        rightColumn
                    }

                    ... on DatoCmsContact {
                        model { apiKey }
                        title
                        sendMailTo
                    }

                    ... on DatoCmsTeam {
                        model { apiKey }
                        teamName
                        showContactButton
                        viewAsList
                        member {
                            name
                            function
                            description
                            linkedin
                            photo {
                                url
                            }
                        }
                    }

                    ...on DatoCmsNewsAndEvent {
                        model { apiKey }
                    }

                    ... on DatoCmsDistributionLocation {
                        model { apiKey }
                        title
                        map {
                            url
                            fluid(maxWidth: 600, imgixParams: { fm: "jpg", auto: "compress" }) {
                              ...GatsbyDatoCmsFluid
                            }
                        }
                        distributor {
                            address
                            region
                            phoneNumber
                            website
                            name
                            eMail
                            originalId
                        }
                    }
                }
            }
        
    }
`
